import {
  CreateLinkRequest,
  EditLinkRequest,
  LinksResponse,
} from "@/@types/Links";
import { api } from "./api";

interface GetLinksParams {
  productId: string | undefined;
  page: number;
}

interface CreateLinkParams {
  data: CreateLinkRequest;
  productId: string | undefined;
}

interface UpdateLinkParams {
  data: EditLinkRequest;
  linkId: string;
  productId: string | undefined;
}

interface DeleteLinkParams {
  linkId: string;
  productId: string | undefined;
}

export class LinksService {
  static async getLinks({
    productId,
    page,
  }: GetLinksParams): Promise<LinksResponse> {
    const response = await api.get(
      `/v1/products/${productId}/links?page=${page}`
    );
    return response.data;
  }

  static async getLinksAsAffiliates({
    productId,
    page,
  }: GetLinksParams): Promise<LinksResponse> {
    const response = await api.get(
      `/v1/products/${productId}/links/affiliates?page=${page}`
    );
    return response.data;
  }

  static async createLink({ data, productId }: CreateLinkParams): Promise<any> {
    const response = await api.post(`/v1/products/${productId}/links`, data);
    return response.data;
  }

  static async updateLink({
    data,
    linkId,
    productId,
  }: UpdateLinkParams): Promise<any> {
    const response = await api.put(
      `/v1/products/${productId}/links/${linkId}`,
      data
    );
    return response.data;
  }

  static async deleteLink({
    linkId,
    productId,
  }: DeleteLinkParams): Promise<any> {
    const response = await api.delete(
      `/v1/products/${productId}/links/${linkId}`
    );
    return response.data;
  }
}
